import React, {useEffect, useContext} from 'react'
import { Link } from 'react-router-dom'
import { getImages } from '../Components/const'
import UseScrollReveal from '../Components/Common/UseScrollReveal ';
import { VehicleContext } from '../Components/Context/VehicleContext';
import SeoMeta from '../Components/Common/SeoMeta';


const LeaseReturn = () => {
    const {getVehicleData,vehicleData,filteredVehicleData,priceFormatter} = useContext(VehicleContext);

    useEffect(() => {
        // const randomIndex = Math.floor(Math.random() * images.length);
        // setBgImage(images[randomIndex]);

        if(!vehicleData) getVehicleData();
    }, []);

    UseScrollReveal();

    return (
        <>
            <SeoMeta
                title="McLaren Lease Return Orlando FL | End of Lease Assistance"
                description="Returning your leased McLaren? Our Orlando team makes the lease return process simple and straightforward. Contact us for guidance today."
                keywords=""
                ogTitle="McLaren Lease Return Orlando FL | End of Lease Assistance"
                ogDescription="Returning your leased McLaren? Our Orlando team makes the lease return process simple and straightforward. Contact us for guidance today."
            />
            <section className='common-banner-wrap'>
                <img src={getImages('lease-return-bg.webp')} alt='lease return' />
                <div className='common-banner-pos pt-140'>
                    <div className='container'>
                        <div className='d-flex align-items-center'>
                            <div className='w-100'>
                                <h4 className='xs-title text-uppercase font-1-1em fw-300 text-lgray wow reveal fadeIn'>McLaren Orlando</h4>
                                <h1 className='lg-title text-uppercase mt-2 wow reveal fadeIn'>Lease Return</h1>
                                <div className='mt-4 wow reveal fadeIn'>
                                    <Link to="/contact" className='theme-btn text-uppercase d-inline-block'>Schedule Appointment</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='common-wrap'>
                <div className='container'>
                    <div className='mb-5'>
                        <h4 className='xs-title fw-bold text-orange text-uppercase mt-5 wow reveal fadeInUp'>McLaren Orlando</h4>
                        <h2 className='lg-title text-gray fw-300 text-uppercase mt-2 wow reveal fadeInUp'>Certified McLaren Lease Return</h2>
                        <div className='common-text wow reveal fadeInUp'>
                            <p>We want every journey in your McLaren to be as good as the first. So when it comes to looking after you, we’re in it for the long-haul. In fact, we put as much pride into building a long-term relationship with you as we do into building our cars. So whenever you need McLaren, you can expect first-class advice and support from McLaren Orlando. Day in. Day out. If you are also a sport scar enthusiast living in or around Orlando, FL this is for you. McLaren Orlando is offering the option for McLaren lease returns. Learn more about our official McLaren lease return center in Orlando, FL</p>

                            <p>Leasing the McLaren 720S Spider from McLaren Orlando in Titusville is an easy way to get a 2020 McLaren 720S Spider that still has a lot of life left in its wheels! We take pride in our McLaren, and we make sure customers come back from a leasing agreement that they’re still in prime condition. This means that you can rest assured that our selection is going to provide you with a McLaren that has always been maintained by certified McLaren technicians at our dealership.</p>
                        </div>
                    </div>
                    <div className='mb-5'>
                        <h4 className='xs-title fw-bold text-orange text-uppercase mt-5 wow reveal fadeInUp'>McLaren Orlando</h4>
                        <h2 className='lg-title text-gray fw-300 text-uppercase mt-2 wow reveal fadeInUp'>McLaren Ownership</h2>
                        <div className='common-text wow reveal fadeInUp'>
                            <p>For various reasons, you may end up opting out of lease early, which provides McLaren Orlando with the opportunity to offer you a current 2020 McLaren 720S Spider at a great price. You’ll be able to get the model you’ve been dreaming of without having to settle for a used version that is many years old. We create driving experiences like no other. We want you to get the most out of your McLaren. Every day. And we follow the same principles for our warranties and service contracts as we do for our cars. So they are uncompromising.</p>
                        </div>
                    </div>
                    <h4 className='xs-title fw-bold text-orange text-uppercase mt-5 wow reveal fadeInUp'>Explore some our</h4>
                    <h2 className='lg-title text-gray fw-300 text-uppercase mt-2 mb-4 wow reveal fadeInUp'>Lease Deals & Offers</h2>
                </div>
                <div className='container mxw-1360'>
                    <div className='row g-32'>
                        {filteredVehicleData && filteredVehicleData.filter(item => item.inventory_manage.lease_special).map((item, index) =>
                            <div className='col-md-4 wow reveal fadeInUp' key={index}>
                                <div className='ls-box'>
                                    <div className='ls-image'>
                                        <img src={item.images[0]} alt='lease special' />
                                    </div>
                                    <div className='ls-content'>
                                        <div className='d-flex align-items-center mb-2 justify-content-between'>
                                            <div className='xs-title font-1-2em text-orange text-uppercase fw-bold'>Lease Special</div>
                                            <div className='mb-1'>
                                                <button className='info-icon'>
                                                    <img src={getImages('info-icon.svg')} alt='icon' />
                                                </button>
                                            </div>
                                        </div>
                                        <div className='xs-title font-1-1em mb-1 title-ellipsis'>{item.vehicle_name}</div>
                                        <div className='d-flex align-items-center'>
                                            <span className='fv-price font-2em'>{priceFormatter(item.inventory_manage.price_per_month,true)}</span>
                                            <span className='fv-mileage font-0-9em ps-3 d-inline-block'>Per Month</span>
                                        </div>
                                        <div className='ls-text'>
                                            {/*<p>Lease offer valid thru Nov 30, 2025. As advertised lorem ipsum semper duet with har daus kradem… <span className='text-orange'>More details</span></p>*/}
                                            <p>{item.inventory_manage.description}</p>
                                            <p>{item.inventory_manage.disclaimer}</p>
                                        </div>
                                        <div className='text-center'>
                                            <button type='button' className='theme-btn text-uppercase'>View Details</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}

export default LeaseReturn